import { useState, useEffect } from 'react';
import { ReduxStore } from '../../../store/reducers';
import { ThunkDispatch } from 'redux-thunk';
import { SetUserObject } from '../../../store/actions/user/UserActions';
import { connect } from 'react-redux';
import { withNavBar } from "../../shared/NavBar/NavBar"; 
import sharedHistory from "../../../shared/History";
import { RouteNames } from "../../../shared/enums/RouteNames";
import useLocalization from "../../../shared/useLocalization/useLocalization";
import "./DeactivateAccountSuccess.scss";

const DeactivateAccountSuccess = ({userObject, setUserObject}: IDeactivateAccountSuccessProps) => {
	const local = useLocalization();
	const [userGivenName, setUserGivenName] = useState('');

	useEffect(() => {
		userObject.attributes?.given_name ? 
			setUserGivenName(userObject.attributes.given_name) : setUserGivenName('Goodbye');

		setUserObject({});
	}, [])

  const doneClicked = () => {
    sharedHistory.push(RouteNames.Home);
  };

  return (
    <>
      <h4 className="main_title" data-testid="mainTitle">
        {local?.t("deactivateAccountSuccess.title")}
      </h4>
      <div className="row">
        <div className="col m9 s12">
          <h3 className="center valign-wrapper">
            <i className="medium material-icons success">check</i> 
            {local?.t("deactivateAccountSuccess.subTitle")}
          </h3>
        </div>
        <div className="col m3 s12">
          <button
            className="btn btn-primary"
            data-testid="doneButton"
            onClick={doneClicked}
          >
            {local?.t("deactivateAccountSuccess.doneButtonText")}
          </button>
        </div>
      </div>
      <div className="row">
        <div className="col s12 font-weight-bold">
          { `${userGivenName}, ${local?.t("deactivateAccountSuccess.text")}`}
        </div>
      </div>
    </>
  );
}; 

const stateToProps = (state: ReduxStore) => {
  return { userObject: state.User.UserObject }
}

const dispatchToProps = (dispatch: ThunkDispatch<{}, {}, any>) => ({
  setUserObject: (userObject: ICognitoUser) => dispatch(SetUserObject(userObject))
});

export default withNavBar(connect(stateToProps, dispatchToProps)(DeactivateAccountSuccess), true);